export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9846.ab7ccb6d.jpg";